'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PolicyCode$() {
  this.c9j = null;
  this.c9k = false;
  this.c9h = null;
  this.c9i = false;
}
export { $c_Lpresto_types$PolicyCode$ as $c_Lpresto_types$PolicyCode$ };
$p = $c_Lpresto_types$PolicyCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PolicyCode$;
/** @constructor */
function $h_Lpresto_types$PolicyCode$() {
}
export { $h_Lpresto_types$PolicyCode$ as $h_Lpresto_types$PolicyCode$ };
$h_Lpresto_types$PolicyCode$.prototype = $p;
$p.ae7 = (function() {
  if ((!this.c9k)) {
    this.c9j = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c9k = true;
  }
  return this.c9j;
});
$p.Ti = (function() {
  if ((!this.c9i)) {
    this.c9h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c9i = true;
  }
  return this.c9h;
});
var $d_Lpresto_types$PolicyCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PolicyCode$, "presto.types$PolicyCode$", ({
  a0W: 1,
  D: 1
}));
export { $d_Lpresto_types$PolicyCode$ as $d_Lpresto_types$PolicyCode$ };
var $n_Lpresto_types$PolicyCode$;
function $m_Lpresto_types$PolicyCode$() {
  if ((!$n_Lpresto_types$PolicyCode$)) {
    $n_Lpresto_types$PolicyCode$ = new $c_Lpresto_types$PolicyCode$();
  }
  return $n_Lpresto_types$PolicyCode$;
}
export { $m_Lpresto_types$PolicyCode$ as $m_Lpresto_types$PolicyCode$ };
//# sourceMappingURL=presto.types$-Policy-Code$.js.map
